const actions = {
    Date_Range: 'Date_Range',
    SetDateRange: (data) => ({
        type: actions.Date_Range,
        payload: {data},
    }),

};
export default actions;
